import { Grid } from "@mui/material";
import { Drawer, Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import logo from "../assets/logo.png";
import { useDispatch } from "react-redux";
import { logout } from "../features/authSlice";
import { logoutService } from "../services/loginService";
import { resetContacts } from "../features/contactSlice";

// Fixed width so every nav button is the same size regardless of label length.
const NAV_BUTTON_WIDTH = 176;

const NavDrawer = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Order: Search sits just above QuickAssessor. `variant: "contained"`
  // highlights the primary workspace (QuickAssessor).
  const navItems = [
    { label: "Dashboard", onClick: () => navigate("/app/dashboard") },
    {
      label: "Search",
      onClick: () => {
        dispatch(resetContacts());
        navigate("/app/search");
      },
    },
    {
      label: "QuickAssessor",
      variant: "contained",
      onClick: () => navigate("/app/quickAssessor"),
    },
    { label: "Reports", onClick: () => navigate("/app/reports") },
    { label: "Import", onClick: () => navigate("/app/import") },
    { label: "Settings", onClick: () => navigate("/app/settings") },
    {
      label: "Logout",
      onClick: () => {
        navigate("/");
        logoutService();
        dispatch(logout());
      },
    },
  ];

  return (
    <Grid container>
      <Grid item>
        <Drawer
          variant="temporary"
          anchor="left"
          open={open}
          onClose={() => setOpen(!open)}
        >
          <Grid container direction="column" textAlign="center" spacing={3}>
            <Grid item>
              <Button onClick={() => setOpen(!open)} sx={{ color: "black" }}>
                <img src={logo} alt="logo" height={50} />
                <ArrowForwardIcon sx={{ padding: 1 }} />
              </Button>
            </Grid>

            {navItems.map(({ label, variant, onClick }) => {
              const contained = variant === "contained";
              return (
                <Grid item key={label}>
                  <Button
                    variant={variant || "outlined"}
                    onClick={onClick}
                    sx={{
                      width: NAV_BUTTON_WIDTH,
                      ...(contained ? {} : { color: "black" }),
                    }}
                  >
                    {label}
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </Drawer>
        <Button onClick={() => setOpen(!open)} sx={{ color: "black" }}>
          <ArrowBackIcon sx={{ padding: 1 }} />
          <img src={logo} alt="logo" height={50} />
        </Button>
      </Grid>
    </Grid>
  );
};

export default NavDrawer;
